module.exports = function () {
  return new Worker("/" + "./assets/08085a523a1479c838fa.worker.js");
};